export default __webpack_public_path__ + "static/media/M1A_2.c8abc413.png";